/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
import moment from 'moment';
import cabine from '../../../services/cabineApi';
import { gotErrorFromApi } from '../../../utils/api';
import {
  getAccountingV2ReportFromApi,
  gotAccountingV2ReportFromApi,
  gotErrorFromAccountingV2ReportApi,
} from '../../duck/legado/accountingAppV2';
import {
  getAnaliticDataFromApi,
  gotAnaliticDataFromApi,
  gotErrorFromAnaliticDataApi,
} from '../../duck/legado/accountingAppV2/analiticData';
import { SendLoginTokenAuth } from '../tokens';

export function getAccountingV2(init: string, final:string = "",partner: string) {
  const initialDate = moment(init).format('YYYY-MM-DD');
  const finalDate = moment(final).format('YYYY-MM-DD');

  return (dispatch: any) => {
    dispatch(getAccountingV2ReportFromApi());
    cabine
      .get(
        `/v1/legado/relatorio/lista/contabil/${partner}/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotAccountingV2ReportFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromAccountingV2ReportApi);
      });
  };
}

export function getUnifiedReportExcel(init: string, final:string = "",partner: string) {
  const initialDate = moment(init).format('YYYY-MM-DD');
  const finalDate = moment(final).format('YYYY-MM-DD');

  return (dispatch: any) => {
    dispatch(getAccountingV2ReportFromApi());
    cabine
      .get(
        `/v1/legado/relatorio/lista/contabil/${partner}/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotAccountingV2ReportFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromAccountingV2ReportApi);
      });
  };
}

export function checkTwoDateDocument(init: string, final:string = "") {
  const initialDate = moment(init).format('YYYY-MM-DD');
  const finalDate = moment(final).format('YYYY-MM-DD');

  return (dispatch: any) => {
    dispatch(getAccountingV2ReportFromApi());
    cabine
      .get(
        `/v1/legado/relatorio/lista/contabil/${initialDate}/${finalDate}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotAccountingV2ReportFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromAccountingV2ReportApi);
      });
  };
}

export function getAnaliticDataV2(
  initialDate: string,
  finalDate: string,
  partner: 'fiducia' | 'terceiros',
  path: string,
  searchPriotity: string
) {
  return (dispatch: any) => {
    dispatch(getAnaliticDataFromApi());
    cabine
      .get(
        `/v1/legado/relatorio/contabil/${partner}/${initialDate}/${finalDate}${path}`,
        SendLoginTokenAuth()
      )
      .then((response: any) => {
        response.data.prioridade_de_pesquisa = searchPriotity;
        response.data.data_de_pesquisa = {
          de: initialDate,
          ate: finalDate,
        };
        dispatch(gotAnaliticDataFromApi(response.data));
      })
      .catch((error: any) => {
        gotErrorFromApi(error, dispatch, gotErrorFromAnaliticDataApi);
      });
  };
}
